import { observer } from 'mobx-react'
import React from 'react'
import styles from './OCRScopingJobMainPanel.sass'
import cx from 'classnames'
import OCRScopingJobsViewModel from 'jobs/screens/OCRScopingJobs/OCRScopingJobsViewModel'
import OCRScopeJobDetailBody from './OCRScopeJobDetailBody'
import OCRScopeJobDetailHeader from './OCRScopeJobDetailHeader'
import OCRScopeJobDetailFooter from './OCRScopeJobDetailFooter'
import ContentLoading from '../../../../../components/ContentLoading'
import ContentError from '../../../../../components/ContentError'
import JobCreationDialog from '../../../../creation/views/JobCreationDialog'
import OCRConfirmReviewModal from '../Modals/OCRConfirmReviewModal'
import OCRConfirmSubmitModal from '../Modals/OCRConfirmSubmitModal'
import OCRConfirmArchiveModal from '../Modals/OCRConfirmArchiveModal'

interface OCRScopeJobEmptyStateProps {
  vm: OCRScopingJobsViewModel
}

export default observer(function OCRScopingJobMainPanel({
  vm,
}: OCRScopeJobEmptyStateProps) {
  return vm.ocrScopingJobMainPanelViewModel.activate.match({
    pending: () => <ContentLoading />,
    rejected: (err) => <ContentError error={err} />,
    resolved: () => (
      <div className={cx(styles.mainPanelContainer)}>
        <OCRScopeJobDetailHeader vm={vm.ocrScopingJobMainPanelViewModel} />
        <OCRScopeJobDetailBody vm={vm} />
        <OCRScopeJobDetailFooter vm={vm.ocrScopingJobMainPanelViewModel} />
        <JobCreationDialog
          vm={vm.ocrScopingJobMainPanelViewModel.jobCreationDialogVM}
        />
        <OCRConfirmReviewModal
          vm={vm.ocrScopingJobMainPanelViewModel.confirmReviewModalVM}
        />
        <OCRConfirmSubmitModal
          vm={vm.ocrScopingJobMainPanelViewModel.confirmSubmitModalVM}
        />
        <OCRConfirmArchiveModal
          vm={vm.ocrScopingJobMainPanelViewModel.confirmArchiveModalVM}
        />
      </div>
    ),
  })
})
